import type { ParseType, ParsedImageInfo } from '../types';

/**
 * 文档解析请求参数
 */
export interface DocumentParseRequest {
    /** 文档文件（支持PDF和DOCX格式，最大5MB） */
    file: File;
    /** 解析类型：text_only(只解析文本), image_only(只解析图片), both(解析文本和图片) */
    parse_type: ParseType;
    /** 文件夹路径，用于组织文件存储结构 */
    folder_path?: string;
    /** 文件名前缀，用于标识文件用途 */
    file_prefix?: string;
    /** 是否生成唯一文件名 */
    generate_unique_name?: boolean;
}

/**
 * 文档解析响应
 */
export interface DocumentParseResponse {
    /** 解析类型 */
    parse_type: ParseType;
    /** 原始文件名 */
    original_file_name: string;
    /** 文件大小（字节） */
    file_size: number;
    /** 文件类型 */
    file_type: string;
    /** 解析的文本内容 */
    text_content: string;
    /** 解析的图片信息列表 */
    images: ParsedImageInfo[];
    /** 解析状态 */
    status: string;
    /** 解析耗时（毫秒） */
    processing_time: number;
}

export const DocumentParseApi = Symbol.for('DocumentParseApi');

/**
 * 文档解析 API 接口
 * @description 提供文档解析相关的 API 调用
 */
export interface DocumentParseApi {
    /**
     * 解析PDF或Word文档
     * @param request 解析请求参数
     * @returns 文档解析响应
     */
    parseDocument(request: DocumentParseRequest): Promise<DocumentParseResponse>;
}
